import { render, staticRenderFns } from "./catDetail.vue?vue&type=template&id=74bebbf4&scoped=true"
import script from "./catDetail.vue?vue&type=script&lang=ts"
export * from "./catDetail.vue?vue&type=script&lang=ts"
import style0 from "./catDetail.vue?vue&type=style&index=0&id=74bebbf4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bebbf4",
  null
  
)

export default component.exports